import { i18n } from 'src/i18n';
import FormCategoryService from 'src/modules/formCategory/formCategoryService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';
import formCategoryListActions from '../list/formCategoryListActions';

const prefix = 'FORMCATEGORY_FORM';

const formCategoryFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: formCategoryFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await FormCategoryService.find(id);
      }

      dispatch({
        type: formCategoryFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: formCategoryFormActions.INIT_ERROR,
      });

      getHistory().push('/form-category');
    }
  },

  doCopy: (values) => async (dispatch) => {
    try {
      dispatch({
        type: formCategoryFormActions.CREATE_STARTED,
      });

      await FormCategoryService.create(values);

      dispatch({
        type: formCategoryFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.formCategory.create.success'),
      );

      dispatch(formCategoryListActions.doCopyFetch());
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: formCategoryFormActions.CREATE_ERROR,
      });
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: formCategoryFormActions.CREATE_STARTED,
      });

      await FormCategoryService.create(values);

      dispatch({
        type: formCategoryFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.formCategory.create.success'),
      );

      getHistory().push('/form-category');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: formCategoryFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, _getState) => {
    try {
      dispatch({
        type: formCategoryFormActions.UPDATE_STARTED,
      });

      await FormCategoryService.update(id, values);

      dispatch({
        type: formCategoryFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.formCategory.update.success'),
      );

      getHistory().push('/form-category');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: formCategoryFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default formCategoryFormActions;
